import { render, staticRenderFns } from "./PriorityControls.vue?vue&type=template&id=cc4bad90&"
import script from "./PriorityControls.vue?vue&type=script&lang=js&"
export * from "./PriorityControls.vue?vue&type=script&lang=js&"
import style0 from "./PriorityControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VFlex,VIcon,VProgressCircular,VSwitch,VTextField})
